import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface ListLeadRow {
  id: string;
  name: string;
  organization_number: string | null;
  status: string;
  attempts_count: number;
  last_outcome: string | null;
  anonymized_at: string | null;
}

/** Leads i en liste for admin (maks 200, valgfritt navnesøk). Brukes til «Slett person». */
export function useListLeads(listId: string | undefined, search: string) {
  const term = search.trim();
  return useQuery({
    queryKey: ["list-leads", listId, { search: term }],
    queryFn: async (): Promise<ListLeadRow[]> => {
      let query = supabase
        .from("leads")
        .select("id, name, organization_number, status, attempts_count, last_outcome, anonymized_at")
        .eq("list_id", listId!)
        .is("anonymized_at", null)
        .order("name")
        .limit(200);
      if (term) query = query.ilike("name", `%${term.replace(/[%_]/g, "")}%`);
      const { data, error } = await query;
      if (error) throw error;
      return (data ?? []) as ListLeadRow[];
    },
    enabled: !!listId,
    staleTime: 30 * 1000,
  });
}
